import { render } from "./template.vue?vue&type=template&id=9325a820&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"

import "./style.scss?vue&type=style&index=0&id=9325a820&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9325a820"]])

export default __exports__